import React, { FC } from 'react';

type PillType = {
  value: string | number;
  classNames?: string;
};

const Pill: FC<PillType> = ({ value, classNames }) => (
  <span
    data-testid="pill"
    className={`rounded-lg items-center text-sm py-0.5 px-2 font-bold self-start ${classNames}`}
  >
    {value}
  </span>
);

export default Pill;
